import { PerformanceMarkers } from './common-enum';

class AppPerformanceTracker {
    private static instance: AppPerformanceTracker;

    private appStartTime: number;

    private infoCallTiming: PerformanceResourceTiming | null = null;

    private constructor() {
        this.initializeInfoCallTracking();
    }

    private initializeInfoCallTracking() {
        const observer = new PerformanceObserver(list => {
            const infoEntry = list
                .getEntries()
                .find(e => e.name.includes('prism/preauth/info')) as
                | PerformanceResourceTiming
                | undefined;
            if (!infoEntry) return;

            // Store timing data in memory; defer mark creation until needed
            this.infoCallTiming = infoEntry;
            this.appStartTime = infoEntry.startTime;
            observer.disconnect();
        });
        observer.observe({ entryTypes: ['resource'] });
    }

    /**
     * Get the stored info call timing data directly.
     * Returns null if info call hasn't completed yet.
     */
    public getInfoCallTiming(): PerformanceResourceTiming | null {
        return this.infoCallTiming;
    }

    public static getInstance(): AppPerformanceTracker {
        if (!AppPerformanceTracker.instance) {
            AppPerformanceTracker.instance = new AppPerformanceTracker();
        }
        return AppPerformanceTracker.instance;
    }

    public markAppMount() {
        // Create APP_START_TIME mark from stored data if available
        if (this.infoCallTiming) {
            performance.mark(PerformanceMarkers.APP_START_TIME, {
                startTime: this.infoCallTiming.startTime,
            });
        }
        performance.mark(PerformanceMarkers.APP_MOUNTED);
    }
}

export const appPerformanceTracker = AppPerformanceTracker.getInstance();
